import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { ArrowLeft, Loader2, LockKeyhole, ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import Logo from "@/components/Logo";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import "./LoginFuturistic.css";

export default function ResetPassword() {
  const [params] = useSearchParams(); const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState(""); const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false); const [error, setError] = useState("");
  const submit = async (e) => {
    e.preventDefault(); setError("");
    if (password !== confirm) { setError("As senhas não coincidem."); return; }
    setBusy(true);
    try { const { data } = await api.post("/auth/reset-password", { token, new_password: password }); toast.success(data.message); navigate("/login", {replace:true}); }
    catch (err) { setError(formatApiError(err)); }
    finally { setBusy(false); }
  };
  return (
    <main className="ms-login" data-testid="reset-password-page">
      <div className="ms-login-grid" aria-hidden="true" />
      <div className="ms-login-glow ms-login-glow-one" aria-hidden="true" />
      <section className="ms-login-panel" style={{ maxWidth: 520, margin: "auto", width: "100%" }}>
        <form onSubmit={submit} className="ms-auth-card" data-testid="reset-password-form">
          <div className="ms-auth-brand">
            <Logo size={62} />
            <strong>MS Soluções Financeiras</strong>
            <span>NOVA SENHA</span>
          </div>
          <div className="ms-auth-heading">
            <h2>Redefinir senha</h2>
            <p>Informe e confirme a nova senha para concluir a recuperação.</p>
          </div>
          {!token && (
            <div className="ms-auth-error" role="alert">
              Este link não contém um token de recuperação. Solicite um novo link para receber o endereço correto.
            </div>
          )}
          <div className="ms-auth-field">
            <Label htmlFor="new-password"><LockKeyhole /> Nova senha</Label>
            <Input
              id="new-password"
              type="password"
              minLength={6}
              required
              autoComplete="new-password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="ms-auth-input"
              data-testid="reset-password-input"
            />
          </div>
          <div className="ms-auth-field">
            <Label htmlFor="confirm-password"><LockKeyhole /> Confirmar nova senha</Label>
            <Input
              id="confirm-password"
              type="password"
              minLength={6}
              required
              autoComplete="new-password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              className="ms-auth-input"
              data-testid="reset-confirm-password-input"
            />
          </div>
          {error && <div className="ms-auth-error" role="alert">{error}</div>}
          <Button type="submit" disabled={busy || !token} className="ms-auth-submit" data-testid="reset-submit">
            {busy ? <Loader2 className="animate-spin" /> : "Salvar nova senha"}
          </Button>
          {!token && (
            <p className="ms-auth-register">
              <Link to="/forgot-password">Solicitar um novo link de recuperação</Link>
            </p>
          )}
          <p className="ms-auth-register"><Link to="/login"><ArrowLeft /> Voltar para o login</Link></p>
          <div className="ms-auth-secure"><ShieldCheck /> CONEXÃO PROTEGIDA · SEUS DADOS SÃO PRIVADOS</div>
        </form>
      </section>
    </main>
  );
}
